import { Col, Form, FormInstance, Input, Row, Select, message, Button, Checkbox, CheckboxProps } from 'antd';
import {
  getDistrict,
  getProvince,
  getSubDistrict,
  getValidateAddressDeliveryType,
} from '../../Services/Prescription.service';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import * as input from '../Layouts/FormInput.Style';
import { DataContext } from '../../Pages/Prescription/PrescriptionForm';
import { AddressDelivery, CountryType, SiteType, ValueType } from '../../Pages/Prescription/InterfaceType';
import TextArea from 'antd/es/input/TextArea';
import DeliveryAddressModal from '../Modal/Address/DeliveryAddressModal';
import { getProfileAddress } from '../../Services/Profile.service';
import NumericInput from '../../Utils/NumericInput';
import { isNumeric } from '../../Utils/common';
import { checkStock } from '../../Services/Product.service';
import * as _ from 'lodash';
import { CloseOutlined } from '@ant-design/icons';
import { DELIVERY_CONSTANTS } from '../../Utils/constants';

const DeliveryDetailForm = ({
  form,
  onFinish,
  onChangeDeliveryType,
  itemOnHandBalance: initialItemOnHandBalance,
  updateItemOnHandBalance,
  profileId,
  checkItemList,
  onChangeProfileDeliveryAddress,
  onFastDeliveryAddressSelected,
}: {
  form: FormInstance;
  onFinish: any;
  onChangeDeliveryType: any;
  profileId: string;
  checkItemList: any[];
  itemOnHandBalance: any[];
  updateItemOnHandBalance: (balance: number) => void;
  onChangeProfileDeliveryAddress: (addressId: string) => void;
  onFastDeliveryAddressSelected: (latitude: number, longitude: number) => void;
}) => {
  const { prescriptData, initialData, addressData } = useContext(DataContext);
  const [deliveriesType, setDeliveriesType] = useState('');
  const [provinceCode, setProvinceCode] = useState('');
  const [provinceList, setProvinceList] = useState<CountryType[]>([]);
  const [districtCode, setDistrictCode] = useState('');
  const [districtList, setDistrictList] = useState<CountryType[]>([]);
  const [subDistrictCode, setSubDistrictCode] = useState('');
  const [subDistrictList, setSubDistrictList] = useState<CountryType[]>([]);
  const [deliveries, setDeliveries] = useState<ValueType[]>([]);
  const language = 'th';
  const [disableForm, setDisableForm] = useState(false);
  const [site, setSite] = useState<SiteType[]>([]);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const { Option } = Select;
  const [isOpenAddAddress, setIsOpenAddAddress] = useState(false);
  const [addressList, setAddressList] = useState<AddressDelivery[]>(addressData);
  const [addAddress, setAddAddress] = useState<AddressDelivery | null>(null);
  const [value, setValue] = useState('');
  const [initialAddress, setInitialAddress] = useState('');
  const [itemHaveInstock, setItemHaveInstock] = useState<any[]>([]);
  const [itemOnHandBalance, setItemOnHandBalance] = useState<any[]>(initialItemOnHandBalance);
  const [isFetching, setIsFetching] = useState(false);
  const prevAddressData = useRef<AddressDelivery[] | null>(null);

  const handleChangeLatLong = (value: string) => {
    setValue(value);
  };

  const isFastOrParcelDelivery = (deliveriesType: string) => {
    return deliveriesType === DELIVERY_CONSTANTS.DELIVERY.FAST || deliveriesType === DELIVERY_CONSTANTS.DELIVERY.PARCEL;
  };

  const isFastDelivery = (deliveriesType: string) => {
    return deliveriesType === DELIVERY_CONSTANTS.DELIVERY.FAST;
  };
  useEffect(() => {
    if (initialItemOnHandBalance) {
      setItemOnHandBalance(initialItemOnHandBalance);
    }
  }, [initialItemOnHandBalance]);

  useEffect(() => {
    if (addAddress !== null) {
      setIsChecked(false);
    }
  }, [addAddress]);

  useEffect(() => {
    if (
      profileId &&
      (!prevAddressData.current || JSON.stringify(prevAddressData.current) !== JSON.stringify(addressData))
    ) {
      prevAddressData.current = addressData;
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressData, profileId]);

  const fetchData = async () => {
    if (!profileId || isFetching) return;
    setIsFetching(true);

    try {
      const resAddress = await getProfileAddress(profileId);
      if (resAddress?.datas?.delivery_address) {
        setAddressList(resAddress.datas.delivery_address);
      }
    } catch (error) {
      console.error('Error fetching profile address:', error);
    } finally {
      setIsFetching(false);
    }
  };

  const getConfig = useCallback(() => {
    if (initialData === undefined) {
      return;
    }
    setProvinceList(initialData.provinces);
    setDeliveries(initialData.deliveries);
    setSite(initialData.sites);
  }, [initialData]);

  useEffect(() => {
    if (prescriptData) {
      const fetchData = async () => {
        if (isFastOrParcelDelivery(deliveriesType)) {
          const provinceRes = await getProvince(deliveriesType, language);
          setProvinceList(provinceRes.datas);

          const districtRes = await getDistrict(deliveriesType, provinceCode, language);
          setDistrictList(districtRes.datas);

          const subDistrictRes = await getSubDistrict(deliveriesType, districtCode, language);
          setSubDistrictList(subDistrictRes.datas);
        }
      };
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deliveriesType, language, provinceCode, districtCode]);

  useEffect(() => {
    getConfig();
    if (prescriptData === undefined) {
      return;
    }

    if (prescriptData.prescript_info.display_type === 'VIEW') {
      setDisableForm(true);
    } else if (prescriptData.prescript_info.display_type === 'EDIT') {
      setDisableForm(false);
    }

    setIsChecked(prescriptData.delivery_info.is_save_address);
    setDeliveriesType(prescriptData.delivery_info.type);

    form.setFieldsValue({
      delivery_address: prescriptData.delivery_info.address,
      delivery_zip_code: prescriptData.delivery_info.zip_code,
      delivery_fullname: prescriptData.delivery_info.fullname,
      delivery_phone_number: prescriptData.delivery_info.phone_number,
      latitude_longitude: `${prescriptData.delivery_info.latitude},${prescriptData.delivery_info.longitude}`,
      delivery_type: prescriptData.delivery_info.type,
      delivery_site: prescriptData.delivery_info.site_id,
      remark: prescriptData.remark,
      profile_delivery_address: prescriptData.delivery_info.profile_address_id || '',
      note_to_rider: prescriptData.delivery_info.note_to_rider || '-',
    });

    setProvinceCode(prescriptData.delivery_info.province_code);
    setDistrictCode(prescriptData.delivery_info.district_code);
    onChangeProvince(prescriptData.delivery_info.province_code, 'SET');
    setSubDistrictCode(prescriptData.delivery_info.sub_district_code);
    onChangeDistrict(prescriptData.delivery_info.district_code, 'SET');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prescriptData, initialData]);

  const onChangeProvince = async (provinceCode: string, even: string) => {
    if (!provinceCode || !deliveriesType) return;
    const res = await getDistrict(deliveriesType, provinceCode, language);
    setDistrictList(res.datas);
    setSubDistrictList([]);
    setProvinceCode(provinceCode);

    if (even === 'SELECT') {
      setDistrictCode('');
      setSubDistrictCode('');
    }
  };

  useEffect(() => {
    const profileAddressId = prescriptData?.delivery_info?.profile_address_id;

    if (!profileAddressId) return;

    let selectedAddress = '';
    addressList.forEach((item) => {
      if (item._id === profileAddressId) {
        selectedAddress = `${item.name} - ${item.address}`;
      }
    });

    if (selectedAddress) {
      setInitialAddress(selectedAddress);
    }

    form.setFieldsValue({
      profile_delivery_address: profileAddressId,
    });

    onChangeProfileDeliveryAddress(profileAddressId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressList, prescriptData]);

  useEffect(() => {
    if (provinceList) {
      form.setFieldsValue({
        delivery_province_code: provinceCode,
        delivery_district_code: districtCode,
        delivery_sub_district_code: subDistrictCode,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceList, provinceCode, districtCode, subDistrictCode]);

  const onChangeDistrict = async (districtCode: string, even: string) => {
    const res = await getSubDistrict(deliveriesType, districtCode, language);
    if (res && res.datas) {
      setSubDistrictList(res.datas);
    } else {
      setSubDistrictList([]);
    }
    setDistrictCode(districtCode);

    if (even === 'SELECT') {
      setSubDistrictCode('');
    }
  };

  const onChangeSubDistrict = async (subDistrictCode: string) => {
    setSubDistrictCode(subDistrictCode);
  };

  useEffect(() => {
    if (isChecked) {
      form.setFieldsValue({
        is_save_address: isChecked,
      });
    }
  }, [isChecked, form]);

  const handleKeyPressNumberic = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.key;
    if (isNaN(parseInt(charCode))) {
      event.preventDefault();
    }
  };

  const validateAndUpdateAddress = async (selectedAddress: any) => {
    const {
      name,
      phone_number,
      first_address,
      zipcode,
      latitude,
      longitude,
      sub_district_code,
      district_code,
      province_code,
    } = selectedAddress || {};

    if (!deliveriesType || !sub_district_code) return false;
    const res = await getValidateAddressDeliveryType(deliveriesType, sub_district_code);

    if (res?.res_code === '000') {
      form.setFieldsValue({
        delivery_fullname: name,
        delivery_sub_district_code: sub_district_code,
        delivery_district_code: district_code,
        delivery_phone_number: phone_number,
        delivery_province_code: province_code,
        delivery_address: first_address,
        delivery_zip_code: zipcode,
        latitude_longitude: `${latitude},${longitude}`,
      });

      onChangeProvince(province_code, '');
      onChangeDistrict(district_code, '');
      onChangeSubDistrict(sub_district_code);
      return true;
    } else if (res.res_code === 'E101') {
      message.error('ไม่สามารถใช้ที่อยู่นี้ได้ เนื่องจากอยู่นอกพื้นที่ให้บริการ', 5);
      form.resetFields([
        'delivery_fullname',
        'delivery_sub_district_code',
        'delivery_district_code',
        'delivery_phone_number',
        'delivery_province_code',
        'delivery_address',
        'delivery_zip_code',
        'latitude_longitude',
      ]);
      return false;
    } else {
      message.error('ไม่สามารถใช้ที่อยู่นี้ได้', 5);
      form.resetFields([
        'delivery_fullname',
        'delivery_sub_district_code',
        'delivery_district_code',
        'delivery_phone_number',
        'delivery_province_code',
        'delivery_address',
        'delivery_zip_code',
        'latitude_longitude',
      ]);
      return false;
    }
  };

  const handleSetAddAddress = async (newAddress: any) => {
    setAddAddress(newAddress);
    const isValidAddress = await validateAndUpdateAddress(newAddress);

    const addressId = newAddress?._id || '';

    form.setFieldsValue({
      profile_delivery_address: addressId,
    });

    setInitialAddress(`${newAddress?.name || ''} - ${newAddress?.address || newAddress?.first_address || ''}`);
    onChangeProfileDeliveryAddress(addressId);

    if (isValidAddress && deliveriesType === DELIVERY_CONSTANTS.DELIVERY.FAST) {
      onFastDeliveryAddressSelected(newAddress?.latitude, newAddress?.longitude);
    }
  };

  const checkStockAvailable = async () => {
    const itemId = checkItemList.map((item: any) => item.item_code);
    const siteId = site.map((id) => id.site_id);
    const data = {
      item_code: itemId,
      site_id: siteId,
    };

    const res = await checkStock(data);
    const groupSite: any = _.chain(res.datas)
      .groupBy('site_id')
      .map((value, key) => ({ site_id: key, item: value }))
      .value();
    setItemHaveInstock(groupSite);
  };

  useEffect(() => {
    if (checkItemList.length > 0) {
      checkStockAvailable();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkItemList, itemOnHandBalance]);

  const computedBranchOption = (() => {
    return site.map((e) => {
      const hasInstock = itemHaveInstock.find((id) => Number(id.site_id) === Number(e.site_id));

      checkItemList.forEach((itemInCart) => {
        hasInstock?.item.map((item: any) => {
          if (itemInCart.item_code === item.itm_id) {
            if (item.onhand_balance_qty >= itemInCart.item_qty) {
              item.haveItem = true;
            } else {
              item.haveItem = false;
            }
          }
          return item;
        });
      });

      const checkOutOfStock = hasInstock?.item.find((item: any) => item.haveItem === false);

      return (
        <Option key={e.site_desc} value={e.site_id}>
          {e.site_desc.length > 30 ? `${e.site_desc.slice(0, 30)}...` : e.site_desc}{' '}
          {hasInstock && (
            <span style={{ color: !checkOutOfStock ? 'green' : 'red' }}>
              {!checkOutOfStock ? '[มีสินค้า]' : '[ไม่มีสินค้า]'}
            </span>
          )}
        </Option>
      );
    });
  })();

  const handleOnChangeDeliveryType = async (value: any) => {
    onChangeDeliveryType(value);
    setDeliveriesType(value);

    const rsProvince = await getProvince(value, language);
    setProvinceList(rsProvince.datas);

    if (provinceCode) {
      const rsDistrict = await getDistrict(value, provinceCode, language);
      setDistrictList(rsDistrict.datas);
    }

    const subDistrict = form.getFieldValue('delivery_sub_district_code');
    if (addressList.length > 0 && value === DELIVERY_CONSTANTS.DELIVERY.FAST) {
      await validateAndUpdateAddress(subDistrict);
    }
  };

  const clearAddress = () => {
    setAddAddress(null);
    setInitialAddress('');
    form.setFieldsValue({ profile_delivery_address: '' });
    onChangeProfileDeliveryAddress('');
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const charCode = event.key;
    if (isNaN(parseInt(charCode))) {
      event.preventDefault();
    }
  };

  const selectedDeliveryAddress = (value: any) => {
    setIsOpenAddAddress(true);
  };

  const filterOption = (input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  const onChangeSaveDelivery: CheckboxProps['onChange'] = (e) => {
    setIsChecked(e.target.checked);
  };

  const lastSyncedStockKeyRef = useRef('');

  const getStockSyncKey = (siteId: string) =>
    `${siteId}|${checkItemList
      .map((item) => item.item_code)
      .sort()
      .join(',')}`;

  const syncItemOnHandBalance = async (siteId: string, force = false) => {
    if (!siteId || checkItemList.length === 0) return;

    const key = getStockSyncKey(siteId);
    if (!force && lastSyncedStockKeyRef.current === key) return;
    lastSyncedStockKeyRef.current = key;

    const selectedSite = site.find((item) => item.site_id === siteId);

    if (selectedSite) {
      const response = await checkStock({
        item_code: checkItemList.map((item) => item.item_code),
        site_id: [siteId],
      });
      setItemOnHandBalance(response.datas || []);
      updateItemOnHandBalance(response.datas || []);
    }
  };

  const handleBranchChange = async (siteId: string) => {
    form.setFieldsValue({ delivery_site: siteId });
    await syncItemOnHandBalance(siteId, true);
  };

  useEffect(() => {
    const siteId = form.getFieldValue('delivery_site');
    if (checkItemList.length > 0 && siteId) {
      syncItemOnHandBalance(siteId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkItemList, site]);

  return (
    <div>
      <Form layout="vertical" form={form} onFinish={onFinish} disabled={disableForm}>
        <Row>
          <input.tittle style={{ fontSize: 20, width: 200 }}>ข้อมูลการจัดส่ง</input.tittle>
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              label={'รูปแบบการจัดส่ง'}
              className="left-align"
              name={'delivery_type'}
              rules={[{ required: true }]}
            >
              <Select placeholder="เลือก" onChange={(val) => handleOnChangeDeliveryType(val)}>
                {deliveries.map((e, index) => (
                  <Option key={index} value={e.key}>
                    {e.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label={'รายละเอียดให้พนักงานขับรถ'} className="left-align" name={'note_to_rider'}>
              <TextArea autoSize />
            </Form.Item>
          </Col>

          <Col span={8}>
            {deliveriesType === DELIVERY_CONSTANTS.DELIVERY.PICK_UP ? (
              <Form.Item label={'สาขา'} name={'delivery_site'} rules={[{ required: true }]}>
                <Select
                  filterOption={(input, option: any) => option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  showSearch
                  placeholder="เลือก สาขา"
                  onChange={(val) => handleBranchChange(val)}
                >
                  {computedBranchOption}
                </Select>
              </Form.Item>
            ) : null}

            {isFastOrParcelDelivery(deliveriesType) ? (
              <>
                <Form.Item name="profile_delivery_address" hidden>
                  <Input />
                </Form.Item>

                <Form.Item label={'ที่อยู่ที่บันทึกไว้'} className="left-align">
                  <div style={{ display: 'flex' }}>
                    <Button
                      onClick={() => selectedDeliveryAddress(addAddress)}
                      disabled={profileId === '' || disableForm}
                      style={{
                        flex: 1,
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                      }}
                    >
                      {addAddress ? (
                        <span>{`${addAddress.name} - ${addAddress.short_address?.substring(0, 25)}...`}</span>
                      ) : initialAddress ? (
                        <span>{`${initialAddress?.substring(0, 30)}...`}</span>
                      ) : (
                        <span>เลือกที่อยู่</span>
                      )}
                    </Button>

                    <Button
                      style={{
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderLeftColor: '#fff',
                      }}
                      onClick={clearAddress}
                      disabled={profileId === '' || disableForm}
                      icon={<CloseOutlined />}
                    />
                  </div>
                </Form.Item>
              </>
            ) : null}
          </Col>

          <Col span={3}>
            {isFastDelivery(deliveriesType) && prescriptData?.delivery_info?.delivery_realtime_tracking ? (
              <Form.Item label=" ">
                <div>
                  {prescriptData?.delivery_info?.delivery_realtime_tracking ? (
                    <a
                      href={prescriptData?.delivery_info?.delivery_realtime_tracking}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#00B3F0', textDecoration: 'underline' }}
                    >
                      ติดตามสถานะการจัดส่ง
                    </a>
                  ) : (
                    '-'
                  )}
                </div>
              </Form.Item>
            ) : null}
          </Col>

          <DeliveryAddressModal
            addressType={deliveriesType}
            open={isOpenAddAddress}
            onCancel={() => setIsOpenAddAddress(false)}
            addressList={addressList}
            setAddressList={setAddressList}
            setAddAddress={handleSetAddAddress}
            profileId={profileId}
          />
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) || deliveriesType === DELIVERY_CONSTANTS.DELIVERY.PICK_UP ? (
              <Form.Item label={'ชื่อ-นามสกุล ผู้รับ'} name={'delivery_fullname'} rules={[{ required: true }]}>
                <Input maxLength={250} />
              </Form.Item>
            ) : null}
          </Col>

          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) || deliveriesType === DELIVERY_CONSTANTS.DELIVERY.PICK_UP ? (
              <Form.Item {...isNumeric} label={'เบอร์โทรศัพท์'} name={'delivery_phone_number'}>
                <Input onKeyPress={handleKeyPress} maxLength={10} />
              </Form.Item>
            ) : null}
          </Col>

          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) ? (
              <Form.Item label={'ที่อยู่'} name={'delivery_address'} rules={[{ required: true }]}>
                <Input maxLength={250} />
              </Form.Item>
            ) : null}
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) ? (
              <Form.Item label={'จังหวัด'} name={'delivery_province_code'} rules={[{ required: true }]}>
                <Select
                  showSearch
                  allowClear
                  className="left-align"
                  filterOption={filterOption}
                  placeholder="เลือก จังหวัด"
                  onChange={(e) => onChangeProvince(e, 'SELECT')}
                >
                  {provinceList.map((e, index: number) => (
                    <Option key={index} value={e.province_code}>
                      {e.province_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null}
          </Col>

          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) ? (
              <Form.Item
                label={'เขต/อำเภอ'}
                className="left-align"
                name={'delivery_district_code'}
                rules={[{ required: true }]}
              >
                <Select
                  allowClear
                  showSearch
                  filterOption={filterOption}
                  placeholder="เลือก เขต/อำเภอ"
                  onChange={(e) => onChangeDistrict(e, 'SELECT')}
                >
                  {districtList.map((e, index: number) => (
                    <Option key={index} value={e.district_code}>
                      {e.district_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null}
          </Col>

          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) ? (
              <Form.Item
                label={'แขวง/ตำบล'}
                className="left-align"
                name={'delivery_sub_district_code'}
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  allowClear
                  filterOption={filterOption}
                  placeholder="เลือก แขวง/ตำบล"
                  onChange={onChangeSubDistrict}
                >
                  {subDistrictList.map((e, index: number) => (
                    <Option key={index} value={e.sub_district_code}>
                      {e.sub_district_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            ) : null}
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={8}>
            {isFastOrParcelDelivery(deliveriesType) ? (
              <Form.Item label={'รหัสไปรษณีย์'} name={'delivery_zip_code'} rules={[{ required: true }]}>
                <Input maxLength={5} onKeyPress={handleKeyPressNumberic} />
              </Form.Item>
            ) : null}
          </Col>

          <Col span={8}>
            {deliveriesType === DELIVERY_CONSTANTS.DELIVERY.FAST ? (
              <Form.Item label={'Latitude, Longitude'} name={'latitude_longitude'} rules={[{ required: true }]}>
                <NumericInput
                  style={{ width: '100%' }}
                  value={value}
                  onChange={handleChangeLatLong}
                  placeholder="ex 13.00000,130.000000"
                />
              </Form.Item>
            ) : null}
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Item label={'ความคิดเห็น'} name={'remark'}>
              <TextArea showCount style={{ resize: 'none' }} rows={5} maxLength={500} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          {isFastOrParcelDelivery(deliveriesType) ? (
            <Form.Item name="is_save_address">
              <Checkbox
                checked={isChecked}
                onChange={onChangeSaveDelivery}
                disabled={disableForm || addAddress !== null}
                style={{ padding: 10 }}
              >
                บันทึกข้อมูลการจัดส่งไว้ใช้ครั้งถัดไป
              </Checkbox>
            </Form.Item>
          ) : null}
        </Row>
      </Form>
    </div>
  );
};

export default DeliveryDetailForm;
